import { render } from "./OptionsDropdownWithSubscript.vue?vue&type=template&id=ca01c2cc&scoped=true"
import script from "./OptionsDropdownWithSubscript.vue?vue&type=script&lang=js"
export * from "./OptionsDropdownWithSubscript.vue?vue&type=script&lang=js"

import "./OptionsDropdownWithSubscript.vue?vue&type=style&index=0&id=ca01c2cc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca01c2cc"]])

export default __exports__